<div class="container">

  <div class="row mt-3 mb-2 justify-content-center">
    <div class="col-auto">
      <p class="fw-bold">{{ title }}</p>
    </div>
  </div>

  <ng-container *ngIf="type === 'reports'">

    <div class="row mt-3 mb-2 justify-content-center">

      <div class="col-auto">

        <mat-form-field>
          <mat-label>Meses</mat-label>
          <mat-select [formControl]="monthControl" multiple
            (selectionChange)="onChangeMonth($event)" #monthSelect>
            <mat-checkbox (change)='onSelectAll($event)' class="ps-3" [(ngModel)]="allMonthsSelected">
              Todos
            </mat-checkbox>
            <mat-select-trigger>
              <span *ngIf="allMonthsSelected" class="example-additional-selection">
                Todos
              </span>
              <span *ngIf="!allMonthsSelected" class="example-additional-selection">
                {{ getSelectedMonthsNames() }}
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let card of monthList; trackBy: trackByIndex" [value]="card.number">{{card.name}}</mat-option>
          </mat-select>
        </mat-form-field>

      </div>

      <div class="col-auto">

        <app-select class="ms-3" [formControl]="yearFilterBalance"
          [config]="{ label: 'Año fiscal', options: yearFilterOptions }">
        </app-select>

      </div>

    </div>

  </ng-container>

  <ng-container *ngIf="type === 'perdidasyganancias' || type === 'balancepymes' || type === 'balancesumasysaldos'">

    <div class="row mt-3 mb-2 justify-content-center">

      <div class="col-auto">

        <app-select [formControl]="fromFilterBalance"
          [config]="{ label: 'Desde', options: fromToFilterBalanceOptions }">
        </app-select>

      </div>

      <div class="col-auto">

        <app-select class="ms-3" [formControl]="toFilterBalance"
          [config]="{ label: 'Hasta', options: fromToFilterBalanceOptions }">
        </app-select>

      </div>

      <div class="col-auto">

        <ng-container *ngIf="type === 'balancesumasysaldos'">
          <app-select class="ms-3" [(ngModel)]="levelAccounts" (ngModelChange)="changeLevelAccounts($event)"
            [config]="{ placeholder: 'Niveles', options: levelAccountsOptions }">
          </app-select>
        </ng-container>

      </div>

      <div class="col-auto">

        <app-select class="ms-3" [formControl]="yearFilterBalance"
          [config]="{ label: 'Año fiscal', options: yearFilterOptions }">
        </app-select>

      </div>

    </div>

  </ng-container>

  <ng-container *ngIf="type === 'balancesumasysaldos'">

    <div class="row mt-3 mb-2 justify-content-center">

      <div class="col-10 col-md-auto">
        <label class="me-2">Grupos:</label>
        <mat-checkbox class="me-2" [(ngModel)]="group[1].checked">1</mat-checkbox>
        <mat-checkbox class="me-2" [(ngModel)]="group[2].checked">2</mat-checkbox>
        <mat-checkbox class="me-2" [(ngModel)]="group[3].checked">3</mat-checkbox>
        <mat-checkbox class="me-2" [(ngModel)]="group[4].checked">4</mat-checkbox>
        <mat-checkbox class="me-2" [(ngModel)]="group[5].checked">5</mat-checkbox>
        <mat-checkbox class="me-2" [(ngModel)]="group[6].checked">6</mat-checkbox>
        <mat-checkbox class="me-2" [(ngModel)]="group[7].checked">7</mat-checkbox>
        <mat-checkbox class="me-2" [(ngModel)]="group[8].checked">8</mat-checkbox>
        <mat-checkbox class="me-2" [(ngModel)]="group[9].checked">9</mat-checkbox>
        <mat-checkbox class="me-2" (change)="toggle(10, $event)">Todas las cuentas</mat-checkbox>
      </div>

    </div>

  </ng-container>

  <div class="row mt-2 mb-4 justify-content-center">
    <div class="col-10 col-md-auto">
      <button mat-stroked-button (click)="download()" class="me-3 mb-2 mb-md-0">
        Consultar
      </button>

      <mat-icon matSuffix class="cf-spin-icon" *ngIf="isLoading === true">autorenew</mat-icon>
    </div>
  </div>

  <div class="row mt-2 mb-4 justify-content-center">
    <div class="col-10 col-md-auto">
      <p>Por favor, tenga en cuenta que este proceso puede llevar más tiempo de lo habitual</p>
    </div>
  </div>

</div>
